import { useState } from 'react';
import { Tabs, Result, Button, ConfigProvider, theme as antdTheme } from 'antd';
import {
  NotificationOutlined,
  SendOutlined,
  HistoryOutlined,
  RollbackOutlined,
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useUserStore } from '@/stores/userStore';
import Publish from './Publish';
import History from './History';
import styles from './BroadcastAdmin.module.css';

function BroadcastAdmin() {
  const navigate = useNavigate();
  const isAdmin = useUserStore((s) => s.isAdmin);
  const [activeKey, setActiveKey] = useState<'publish' | 'history'>('publish');
  const [refreshKey, setRefreshKey] = useState(0);

  if (!isAdmin) {
    return (
      <Result
        status="403"
        title="403"
        subTitle="抱歉，仅产品管理员可访问星舰广播中心。"
        extra={
          <Button type="primary" onClick={() => navigate('/dashboard')}>
            返回驾驶舱
          </Button>
        }
      />
    );
  }

  return (
    <ConfigProvider
      theme={{
        algorithm: antdTheme.darkAlgorithm,
        token: {
          colorPrimary: '#00ffff',
          colorInfo: '#00ffff',
          colorBgContainer: 'rgba(10, 22, 44, 0.85)',
          colorBgElevated: 'rgba(10, 22, 44, 0.95)',
          colorBorder: 'rgba(0, 255, 255, 0.18)',
          colorBorderSecondary: 'rgba(0, 255, 255, 0.12)',
          fontFamily:
            "'PingFang SC', 'Microsoft YaHei', sans-serif",
          borderRadius: 2,
        },
      }}
    >
      <div className={styles.page}>
        <div className={styles.starfield} />
        <div className={styles.gridBackground} />
        <span className={`${styles.hudCorner} ${styles.tl}`} />
        <span className={`${styles.hudCorner} ${styles.tr}`} />
        <span className={`${styles.hudCorner} ${styles.bl}`} />
        <span className={`${styles.hudCorner} ${styles.br}`} />

        <div className={styles.container}>
          <div className={styles.header}>
            <div className={styles.titleGroup}>
              <span className={styles.crumb}>AdenCockpit / BROADCAST CENTER</span>
              <span className={styles.title}>
                <NotificationOutlined className={styles.titleIcon} />
                星舰广播中心
              </span>
              <span className={styles.subtitle}>
                STARSHIP · BROADCAST · CENTER
              </span>
            </div>
            <Button
              icon={<RollbackOutlined />}
              className={styles.backBtn}
              onClick={() => navigate('/dashboard')}
            >
              返回驾驶舱
            </Button>
          </div>

          <Tabs
            activeKey={activeKey}
            onChange={(k) => setActiveKey(k as any)}
            items={[
              {
                key: 'publish',
                label: (
                  <span>
                    <SendOutlined /> 发布广播
                  </span>
                ),
                children: (
                  <Publish
                    onPublished={() => {
                      setRefreshKey((k) => k + 1);
                      setActiveKey('history');
                    }}
                  />
                ),
              },
              {
                key: 'history',
                label: (
                  <span>
                    <HistoryOutlined /> 广播历史
                  </span>
                ),
                children: <History key={refreshKey} />,
              },
            ]}
          />
        </div>
      </div>
    </ConfigProvider>
  );
}

export default BroadcastAdmin;
